import React, { useEffect, useState } from "react";
import { Flex, Input, Text, Button } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { IoMdArrowBack } from "react-icons/io";

import withNavElements from "../../components/withNavElements";
import { getAllStores } from "../../actions/storesActions";
import StoresTable from "./StoresTable";
import { useHistory } from "react-router-dom";
import API from "../../api";
import { toast } from "react-hot-toast";

const TEXT_TIME_TYPING = 500;
let typingTimer = null;

const DashboardStoresPage = () => {
    const history = useHistory();
    const storesState = useSelector((state) => state.storesList);
    const dispatch = useDispatch();
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        dispatch(getAllStores({
            showDeleted: true,
            showInactive: true,
            showNoVisible: true,
            search: '',
            page,
            limit
        }));
    }, [dispatch, page, limit]);

    const onChangeText = (e) => {
        const searchTerm = e.target.value;
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
            dispatch(getAllStores({
                showDeleted: true,
                showInactive: true,
                showNoVisible: true,
                search: searchTerm,
                page: 1,
                limit: 10
            }));
        }, TEXT_TIME_TYPING);
    }

    const toggleStoreActive = async (id, setLoading) => {
        setLoading(true);
        try{
            const { data } = await API.put(`/stores/toggle?id=${id}`);
            if(data.ok){
                toast.success("Tienda actualizada con éxito.");
                dispatch(getAllStores({
                    showDeleted: true,
                    showInactive: true,
                    showNoVisible: true,
                    search: '',
                    page,
                    limit
                }));
            }
            setLoading(false);
        }catch(err){
            setLoading(false);
            console.log(err);
            toast.error("Algo salió mal, inténtalo más tarde.");
        }
    }

    return (
        <>
            <Helmet>
                <title>Dashboard - Stores</title>
            </Helmet>
            <Flex
                flex={1}
                minH="300px"
                h="100%"
                mt="70px"
                py="40px"
                px={{ base: 0, md: "20px" }}
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
            >
                <Flex 
                w='100%'
                justifyContent='center'
                alignItems='center'
                pos='relative'
                >
                    <Button
                        variant="ghost"
                        pos='absolute'
                        left='0'
                        onClick={() => history.goBack()}
                    >
                        <IoMdArrowBack size='25px' />
                    </Button>
                    <Text fontSize="1.5em" fontWeight="400" >
                        Gestión de Tiendas
                    </Text>
                </Flex>
                <Flex
                    mt="40px"
                    w="100%"
                    pt="50px"
                    pb='80px'
                    px={{ base: "40px", md: "40px" }}
                    flex={1}
                    minH="100%"
                    bg="gray.100"
                    borderRadius="10px"
                    justifyContent="center"
                    alignItems="center"
                    flexDir={"column"}
                >
                    <Input
                        alignSelf='flex-end'
                        w='200px'
                        type='text'
                        placeholder="Buscar tienda..."
                        bg={storesState.loading ? 'gray.200' : 'white'}
                        mb='20px'
                        size='sm'
                        onChange={onChangeText}
                        borderRadius='8px'
                    />
                        <StoresTable 
                            stores={storesState.allStores?.stores || []}
                            loading={storesState.loading}
                            error={storesState.error}
                            currentPage={storesState.allStores?.currentPage || 0}
                            totalPages={storesState.allStores?.totalPages || 1}
                            page={page}
                            setPage={setPage}
                            limit={limit}
                            setLimit={setLimit}
                            toggleStoreActive={toggleStoreActive}
                        />
                </Flex>
            </Flex>
        </>
    );
}

export default withNavElements(DashboardStoresPage)